import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../api/baseurl";
import { Modal } from "react-bootstrap";
import "./Spinner.css";
import { useNavigate } from "react-router";
import "./hm-theme.css";

const UploadLabsCsvFile = ({ isOpen, onRequestClose, regulated }) => {
  const [loading, setLoading] = useState(false);
  const [csvFile, setCsvFile] = useState(null);
  const [sendNotification, setSendNotification] = useState(false);

  const url = "/api/labdetails/upload";
  const navigate = useNavigate();

  useEffect(() => {}, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!csvFile) {
      toast.error("Please choose a CSV file to upload.");
      return;
    }
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;

    const formData = new FormData();
    formData.append("file", csvFile);
    formData.append("sendNotification", sendNotification);
    formData.append("regulated", regulated);

    try {
      await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setLoading(false);
      toast.success("CSV file uploaded successfully");
      onRequestClose();
      setCsvFile(null);
      setSendNotification(false);
    } catch (error) {
      setLoading(false);
      onRequestClose();
      handleError(error);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const handleCsvFileChange = (e) => {
    const file = e.target.files[0];
    setCsvFile(file);
  };

  const handleSendNotificationChange = (e) => {
    setSendNotification(e.target.checked);
  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">cloud_upload</i>
          Upload CSV
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="file" className="form-label small fw-semibold">
              Upload File <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              id="file"
              type="file"
              accept=".csv"
              onChange={handleCsvFileChange}
              required
            />
            {csvFile && (
              <div className="mt-2">
                <span className="hm-badge hm-badge-info d-inline-flex align-items-center gap-1">
                  <i className="material-icons" style={{ fontSize: "0.85rem" }}>
                    description
                  </i>
                  {csvFile.name} ({(csvFile.size / 1024).toFixed(1)} KB)
                </span>
              </div>
            )}
          </div>

          <div className="form-check mt-3 mb-4">
            <input
              className="form-check-input"
              type="checkbox"
              id="sendNotification"
              checked={sendNotification}
              onChange={handleSendNotificationChange}
            />
            <label className="form-check-label small fw-semibold" htmlFor="sendNotification">
              Send Notification
            </label>
          </div>

          <div className="d-flex align-items-center justify-content-end gap-2 pt-3 border-top">
            <button
              type="button"
              className="btn btn-outline-secondary rounded-pill px-4"
              onClick={onRequestClose}
            >
              Close
            </button>
            <button type="submit" className="btn-hm-primary px-4" disabled={loading || !csvFile}>
              {loading ? "Uploading..." : "Save"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default UploadLabsCsvFile;

